var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SocialUser } from 'angular-6-social-login';
import { v1 as uuidV1 } from 'uuid';
var GoogleNewLoginProvider = /** @class */ (function () {
    function GoogleNewLoginProvider(clientId, http, apiClientUri) {
        this.clientId = clientId;
        this.http = http;
        this.apiClientUri = apiClientUri;
    }
    GoogleNewLoginProvider.prototype.initialize = function () {
        this.sess = uuidV1();
        return new Promise(function (resolve, _reject) { });
    };
    GoogleNewLoginProvider.prototype.signIn = function (signInOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.oAuthWindow = window.open(_this.apiClientUri + "/login_google_oauth?sess=" + _this.sess, '_blank');
                        _this.oAuthWindow.blur();
                        window.focus();
                        try {
                            var user_1 = new SocialUser();
                            setTimeout(function () {
                                var request = _this.http.get(_this.apiClientUri + "/login_google_oauth?sess=" + _this.sess).subscribe(function (data) {
                                    user_1.idToken = data.token;
                                    user_1.token = data.token;
                                    resolve(user_1);
                                });
                            }, 4000);
                        }
                        catch (er) {
                            reject('Please complete the Google signin process to sign in via Google.');
                        }
                    })];
            });
        });
    };
    GoogleNewLoginProvider.prototype.signOut = function (revoke) {
        return new Promise(function (resolve, reject) {
            // AppleID doesnt have revoke method
            resolve();
        });
    };
    GoogleNewLoginProvider.prototype.loadScript = function (id, src, onload, parentElement) {
        if (parentElement === void 0) { parentElement = null; }
    };
    GoogleNewLoginProvider.PROVIDER_ID = 'GOOGLE';
    return GoogleNewLoginProvider;
}());
export { GoogleNewLoginProvider };
